<template>
  <div class="protocol">
    <el-dialog
      class="protocol-dialog"
      :visible.sync="visible"
      :append-to-body="true"
      :lock-scroll="true"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div slot="title" class="dialog-title">
        <span class="left el-icon-arrow-left" @click="lookAgreemnet"></span>
        <strong>{{ title }}</strong>
        <span class="right el-icon-close" @click="lookAgreemnet"></span>
      </div>
      <div class="dialog-conetent">
        <div class="reset" v-html="argumentContent"></div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :disabled="agreementCounts > 0" @click="lookAgreemnet">
          同意
          <span v-if="agreementCounts > 0">（{{ agreementCounts }}S）</span>
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import { Button } from 'element-ui'
import { polling } from '@/utils'

Vue.use(Button)

const Maps = {
  privacy: { url: process.env.VUE_APP_AGREEMENT_PRIVACY, name: '隐私政策' },
}
export default {
  name: 'protocol',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    type: String,
    needCount: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      agreementCounts: 0,
      argumentContent: '',
      timer: null,
    }
  },
  computed: {
    title() {
      if (Maps[this.type]) {
        return Maps[this.type].name
      }

      return ''
    },
  },
  watch: {
    visible(nV) {
      nV ? this.whenShow() : this.whenHide()
    },
  },
  mounted() {
    if (this.needCount) this.agreementCounts = 5
  },
  methods: {
    whenShow() {
      this.getProtocolContent()
      if (this.needCount) this.startPolling()
    },
    whenHide() {
      this.argumentContent = ''
      this.timer && clearInterval(this.timer)
    },
    getProtocolContent() {
      // eslint-disable // 门户1229迭代guangzhou域名需要转发到www.esign.cn上才能访问
      let  domainForward = `https://www.esign.cn/${Maps[this.type].url}`;
      if (window.location.hostname === 'guangzhou.esign.cn') {
        domainForward = `https://guangzhou.esign.cn/${Maps[this.type].url}`
      }
      const url = `${domainForward}?time=${new Date().getTime()}`

      return this.$axios
        .get(url, {
          timeout: 11000,
          withCredentials: true,
        })
        .then(res => {
          this.argumentContent = res.content
            .replace(/&#32;/g, ' ')
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>')
            .replace(/&amp;quot;/g, "'")
            .replace(/&quot;/g, "'")
            .replace(/&amp;nbsp;/g, ' ')
            .replace(/font-family:[^;]+;/g, c => {
              return c.replace(/'/g, '&quot;')
            })
        })
    },
    startPolling() {
      this.agreementCounts = 5
      this.timer = polling(end => {
        this.agreementCounts -= 1
        if (this.agreementCounts === 0) end()
      })
    },
    lookAgreemnet() {
      this.$emit('update:visible', false)
    },
  },
}
</script>

<style lang="less" scoped>
.protocol-dialog {
  overflow: hidden;
  .reset {
    text-align: left;
  }
  /deep/ .el-dialog {
    width: 50%;
    @media (max-width: 750px) {
      width: 100%;
      height: 100%;
      margin: 0 !important;
    }
    .el-dialog__header {
      padding: 0;
      margin: 0;
      border-bottom: 1px solid #e4e4e4;
      height: 50px;
      @media (max-width: 750px) {
        border: none;
        background: #f7f8fa;
      }
      .dialog-title {
        height: 50px;
        line-height: 50px;
        text-align: left;
        padding-left: 38px;
        font-size: 14px;
        color: #333;
        position: relative;
        @media (max-width: 750px) {
          text-align: center;
          padding-left: 0;
        }
        .left {
          position: absolute;
          left: 11px;
          top: 17px;
          display: none;
          @media (max-width: 750px) {
            display: block;
          }
        }
        .right {
          position: absolute;
          right: 38px;
          top: 16px;
          display: block;
          font-size: 18px;
          color: #585858;
          @media (max-width: 750px) {
            display: none;
          }
        }
      }
    }
    .el-dialog__body {
      padding: 0 38px 20px;
      overflow-y: scroll;
      @media (max-width: 750px) {
        padding: 0 20px;
        max-height: calc(100% - 105px);
      }
    }
    .dialog-conetent {
      max-height: 400px;
      @media (max-width: 750px) {
        max-height: none;
      }
      td {
        border: 1px solid #000;
        a {
          font-size: 13px;
        }
      }
    }
    .el-dialog__footer {
      padding: 0 38px;
      @media (max-width: 750px) {
        padding: 0 18px;
      }
    }
    .dialog-footer {
      text-align: center;
      border-top: 1px solid #eeeeee;
      padding: 20px 0;
      @media (max-width: 750px) {
        padding: 8px 0;
        border-top: 1px solid #e4e4e4;
      }
      .el-button--primary {
        width: 125px;
        color: #fff;
        background-color: #409eff;
        border-color: #409eff;
        @media (max-width: 750px) {
          width: 128px;
        }
      }
      .el-button--primary.is-disabled {
        opacity: 0.4;
      }
    }
    .reset {
      p {
        text-align: justify;
      }
    }
  }
}
</style>
